// @flow

export function useBackHandler(handler: () => boolean) {}
export function exitApp() {}
